var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwogray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.416016,
    y: 0.238281,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F2F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6383 43.2383C25.5743 42.8543 25.5423 42.4596 25.5423 42.0543C25.5423 40.6889 25.7876 39.4516 26.2783 38.3423C26.7903 37.2329 27.4196 36.2303 28.1663 35.3343C28.9129 34.4169 29.7129 33.5743 30.5663 32.8063C31.4409 32.0169 32.2516 31.2703 32.9983 30.5663C33.7449 29.8409 34.3636 29.1263 34.8543 28.4223C35.3663 27.6969 35.6223 26.9289 35.6223 26.1183C35.6223 25.2223 35.2916 24.4863 34.6303 23.9103C33.9689 23.3129 33.1156 23.0143 32.0703 23.0143C31.1743 23.0143 30.3529 23.1956 29.6063 23.5583C28.8809 23.8996 28.1983 24.3689 27.5583 24.9663L25.9583 23.0143C26.8116 22.2463 27.7503 21.6276 28.7743 21.1583C29.8196 20.6889 31.0249 20.4543 32.3903 20.4543C33.3289 20.4543 34.1823 20.5929 34.9503 20.8703C35.7396 21.1476 36.4009 21.5423 36.9343 22.0543C37.4889 22.5449 37.9156 23.1209 38.2143 23.7823C38.5129 24.4436 38.6623 25.1583 38.6623 25.9263C38.6623 26.9503 38.4276 27.8996 37.9583 28.7743C37.5103 29.6276 36.9343 30.4489 36.2303 31.2383C35.5476 32.0063 34.7903 32.7529 33.9583 33.4783C33.1476 34.1823 32.3796 34.9076 31.6543 35.6543C30.9289 36.4009 30.2889 37.1796 29.7343 37.9903C29.2009 38.8009 28.8809 39.6756 28.7743 40.6143H38.6303V43.2383H25.6383Z",
    fill: "#513CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwogray);
export default __webpack_public_path__ + "static/media/twogray.ded441829d151c09ae8cce058b227622.svg";
export { ForwardRef as ReactComponent };